import { GEN_NODE_TYPES, type StudioFlowNode } from '@/features/studio/canvas/types'

/** 生成节点壳体尺寸（不含选中时的外置 prompt dock） */
export function estimateGenNodeSize(node: StudioFlowNode): { w: number; h: number } {
  const nodeType = node.data.nodeType
  if (nodeType === 'gen_audio') return { w: 500, h: 520 }
  const aspect = String(node.data.gen?.params?.aspect_ratio ?? '9:16')
  const parts = aspect.split(':').map(Number)
  const aw = parts[0]
  const ah = parts[1]
  let width = 520
  if (aw && ah) {
    const ratio = aw / ah
    if (ratio >= 1) {
      width = ratio >= 1.5 ? 520 : 420
    } else {
      width = Math.max(300, Math.round(400 * ratio))
    }
  }
  const heroH = aw && ah ? Math.min(400, Math.round(width * (ah / aw))) : 320
  return { w: width, h: 40 + heroH + 160 + 36 }
}

/** 打组 / 布局估算（可用 measured） */
export function estimateNodeSize(node: StudioFlowNode): { w: number; h: number } {
  if (node.type === 'group') {
    const style = node.style as { width?: number; height?: number } | undefined
    return { w: Number(style?.width) || 400, h: Number(style?.height) || 280 }
  }
  const measured = node.measured
  if (measured?.width && measured?.height) {
    return { w: measured.width, h: measured.height }
  }
  if (typeof node.width === 'number' && typeof node.height === 'number') {
    return { w: node.width, h: node.height }
  }
  if (GEN_NODE_TYPES.includes(node.data.nodeType)) return estimateGenNodeSize(node)
  if (node.data.nodeType === 'context') return { w: 260, h: 120 }
  if (node.data.nodeType === 'text') return { w: 400, h: 220 }
  if (node.data.nodeType === 'prompt') return { w: 300, h: 200 }
  if (node.data.nodeType === 'register') return { w: 300, h: 280 }
  if (node.data.nodeType === 'export') return { w: 360, h: 380 }
  if (node.data.nodeType === 'upload' || node.data.nodeType === 'ref_character' || node.data.nodeType === 'ref_scene') {
    return { w: 300, h: 260 }
  }
  return { w: 300, h: 220 }
}
